import { Modal, View, TouchableWithoutFeedback } from "react-native";
import { OrganizationList } from "@clerk/clerk-react";
import { usePathname } from "expo-router";

interface OrganizationSwitcherModalProps {
  visible: boolean;
  onClose: () => void;
}

export const OrganizationSwitcherModal = ({
  visible,
  onClose,
}: OrganizationSwitcherModalProps) => {
  const pathname = usePathname();

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View className="flex-1 bg-black/50 justify-center items-center">
          <TouchableWithoutFeedback>
            <View className="">
              <OrganizationList
                hidePersonal={true}
                afterSelectOrganizationUrl={() => pathname}
              />
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};
